class UploadSettingsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }
  
  getImportSettings(){
    let url = this.config.apiRoot + '/importSettings';
    return this.httpDim.get(url);
  }
  
  updateImportSettings(uploadSettings){
    let url = this.config.apiRoot + '/importSettings';
    return this.httpDim.put(url, uploadSettings);
  }
}
  
UploadSettingsService.$inject = ['httpDim', 'config'];
  
export default UploadSettingsService;
  


// WEBPACK FOOTER //
// ./app/components/uploadSettings/uploadSettings.service.js